import { useState, useEffect } from "react";
import { fetchRetry } from "../utilities/utils";

function AsyncImage(props) {
  const [loadedSrc, setLoadedSrc] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(props.src);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        setLoadedSrc(url);
      } catch (err) {
        console.log(err);
      }
    };
    if (!loadedSrc) fetchData();
  }, [loadedSrc]);

  if (loadedSrc) {
    return (
      <img
        className={props.className}
        src={props.src}
        alt={props.alt}
        referrerPolicy="no-referrer"
      />
    );
  }
  return null;
}
export default AsyncImage;
